<template>
  <div style="width: 100%">
    <div class="text-center" style="width: 100%">
      <button class="card-tarja-btn card-tarja-btn--remove" @click="handleClick" :disabled="isDisabled">
        <v-icon>mdi-television-off</v-icon>
        <span>Remover</span>
      </button>
    </div>

    <ModalConfirmAction
      :visible="showDialog"
      title="Remover exibição na tarja"
      message="Tem certeza que deseja remover a exibição na tarja?"
      confirmText="Remover"
      cancelText="Manter exibição"
      :loading="loading"
      @confirm="removerColaboracaoTarja"
      @cancel="showDialog = false"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { apiClient } from "@/services/api";
import ModalConfirmAction from "@/components/Modal/ModalConfirmAction.vue";

export default {
  components: { ModalConfirmAction },
  props: {
    codProducao: Number,
    idCronometro: Number,
    isDisabled: Boolean,
  },
  data() {
    return {
      loading: false,
      showDialog: false,
      exibirModalConfirmacao: null,
    };
  },
  async created() {
    await this.getConfigTarja({
      cod_producao: this.$store.state.producoes.selectedProducao.cod_producao,
    });
    this.exibirModalConfirmacao = this.configTarja.flg_botao_confirmar_exibicao;
  },
  computed: {
    ...mapGetters({
      configTarja: "tarja_cronometro/getConfigTarja",
    }),
  },
  methods: {
    ...mapActions({
      assignTarjaParams: "tarja_cronometro/assignTarjaParams",
      getConfigTarja: "tarja_cronometro/getConfigTarjaCronometro",
    }),
    handleClick() {
      if (this.exibirModalConfirmacao) {
        this.showDialog = true;
      } else {
        this.removerColaboracaoTarja();
      }
    },
    async removerColaboracaoTarja() {
      await apiClient.patch(
        `atualizarFlgIsFullScreenTarjaCronometro/${this.configTarja.id}/${this.codProducao}`,
        {
          flg_is_fullscreen: false,
        }
      );
      this.loading = true;
      this.assignTarjaParams(null);
      localStorage.removeItem("tarjaParams");
      this.$emit("change");
      setTimeout(() => {
        this.loading = false;
        this.showDialog = false;
      }, 250);
    },
  },
  watch: {
    "$store.state.tarja_cronometro.configTarjaCronometro": function (newValue) {
      this.exibirModalConfirmacao = newValue.flg_botao_confirmar_exibicao;
    },
  },
};
</script>

